/* -------------------------------------- */
/* ###### MESSENGER ###### */
/* -------------------------------------- */

var messenger_el = document.querySelector("#messenger");
if (messenger_el) {
    const html_spin = '<i class="fas fa-spinner fa-spin"></i>';

    var active_conversations = document.querySelector("#active-conversations");
    var right_side_no_conversation = document.querySelector(
        "#messenger-right-side-no-conversation"
    );
    //Left Side
    var left_side = document.querySelector("#messenger-left-side");

    //Right Side
    var right_side = document.querySelector("#messenger-right-side");

    //Right Side Header
    var right_side_header = right_side.querySelector(".chat-header");
    var right_side_header_user_avatar = right_side_header.querySelector(
        ".conversation-details .user-avatar"
    );
    var chat_back_btn = right_side_header.querySelector("#chat-back-button");
    var right_side_header_property_avatar = right_side_header.querySelector(
        ".conversation-details .property-avatar"
    );
    var right_side_header_user_name = right_side_header.querySelector(
        ".conversation-details .details .user-name"
    );
    var right_side_header_property_title = right_side_header.querySelector(
        ".conversation-details .details .property-title"
    );
    //var right_side_header_chat_option = right_side_header.querySelector('#messenger-chat-option');
    var right_side_header_property_url =
        right_side_header.querySelector("#property-url");
    var right_side_header_user_url =
        right_side_header.querySelector("#user-url");

    // Options
    //var archive_conversation_option = right_side_header.querySelector('#archive-conversation-option');

    //Right Side Chat
    var right_side_chat_content = right_side.querySelector(".chat-content");
    var right_side_chat_messages =
        right_side_chat_content.querySelector("#chat-messages");

    //Right Side Footer
    var right_side_chat_footer = right_side.querySelector(".chat-footer");
    var right_side_chat_message_input = right_side_chat_footer.querySelector(
        ".messenger-message-input"
    );
    var right_side_chat_message_submit = right_side_chat_footer.querySelector(
        ".messenger-message-submit"
    );
    var right_side_chat_file_attach_btn = right_side_chat_footer.querySelector(
        "#message-attach-file"
    );
    var right_side_chat_file_input = right_side_chat_footer.querySelector(
        "#message-file-input"
    );

    var file_attachment_preview = right_side_chat_footer.querySelector(
        "#file-attachment-preview"
    );
    var image_attachment_preview = right_side_chat_footer.querySelector(
        "#image-attachment-preview"
    );
    var remove_attachments =
        right_side_chat_footer.querySelectorAll(".remove-attachment");

    //Sidebar
    var sidebar_trigger = document.querySelector("#messenger-sidebar-trigger");
    var sidebar = document.querySelector("#messenger-sidebar");
    var sidebar_close = sidebar.querySelector(".messenger-sidebar-close-btn");
    var sidebar_close_js_hide = sidebar.querySelector(
        ".js-hide-messenger-sidebar"
    );
    var profile_completion_request_btn = sidebar.querySelector(
        "#profile-completion-request-btn"
    );

    // demand Attribution Form

    var demand_attribution_modal = document.querySelector(
        "#NewDemandAttribution"
    );
    var demand_attribution_form = document.querySelector(
        "#messenger-add-demand-attribution"
    );
    var demand_attribution_rooms_group = demand_attribution_form.querySelector(
        "#demand-rooms-group"
    );
    var demand_attribution_start_date_input =
        demand_attribution_form.querySelector("#start_date");
    var demand_attribution_cost_rent_input =
        demand_attribution_form.querySelector("#cost_rent");
    var demand_attribution_cost_charges_input =
        demand_attribution_form.querySelector("#cost_charges");
    var demand_attribution_caution_input =
        demand_attribution_form.querySelector("#caution");
    var demand_attribution_agency_fee_input =
        demand_attribution_form.querySelector("#agency_fee");
    var demand_attribution_cloe_fee_input =
        demand_attribution_form.querySelector("#cloe_fee");

    var today_date = new Date();
    today_date.setHours(0, 0, 0, 0);

    var demand_attribution_start_date_input_datepicker = new Datepicker(
        demand_attribution_start_date_input,
        {
            language: document.documentElement.lang,
            format: "dd/mm/yyyy",
            minDate: today_date,
        }
    );

    let user_id_el = document.querySelector('meta[name="_id"]');
    var user_id = user_id_el.getAttribute("content");
    var owner_id = document.querySelector("#owner_id")
        ? document.querySelector("#owner_id").value
        : null;
    var oldest_message_id = false;
    var recent_message_id = false;
    var loading_conversations = false;
    var new_demand_attribution = false;
    var profile_complete_request = false;
    var has_more_messages = true;
    var loading_messages = false;
    var loading_student_info = false;
    var current_conversation_uuid = "";
    var tmp_image = "";
    var temporaryMsgId = 0;
    var first_time = true;
    var connexion = 0;
    var timeout = 1000000;
    var first_url_load = true;
    var url = new URL(window.location.href);
    var url_id_params = url.searchParams.get("id");

    var new_message_sound = document.createElement("AUDIO");
    document.body.appendChild(new_message_sound);
    new_message_sound.src = "/assets/sounds/new_message.mp3";

    let image_mimes = ["image/jpeg", "image/jpg", "image/png"];
    let file_mimes = [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/zip",
        "application/pdf",
        "application/vnd.rar",
    ];

    var input_event = new Event("input", {
        bubbles: true,
        cancelable: true,
    });

    window.addEventListener("DOMContentLoaded", function () {
        getConversations();
    });

    chat_back_btn.addEventListener("click", function (e) {
        var tmp_conv = document.querySelector(
            `.conversations .conversation-item[data-id="${current_conversation_uuid}"]`
        );
        if (tmp_conv) tmp_conv.classList.remove("active");
        current_conversation_uuid = "";
        oldest_message_id = false;
        recent_message_id = false;
        has_more_messages = true;
        right_side_chat_message_input.value = "";
        remove_attachments[0].click();
        remove_attachments[1].click();
        right_side_chat_messages.innerHTML = "";
        demand_attribution_form.querySelector(".errors").innerHTML = "";
        tmp_image = "";
        left_side.classList.remove("hide");
        right_side.classList.remove("active");
        //console.log(sidebar)
        if (window.messenger_is_owner && !window.messenger_is_admin) {
            sidebar.classList.remove("d-none");
        }
    });

    right_side_chat_content.addEventListener("scroll", function () {
        //if (chatbot_open && window.isDocVisible && window.isDocFocus) markAsSeen()
        if (
            !loading_messages &&
            has_more_messages &&
            right_side_chat_content.scrollTop <= 10
        ) {
            getMessages();
        }
    });

    sidebar_trigger.addEventListener("click", function () {
        sidebar.classList.add("show");
    });

    sidebar_close.addEventListener("click", function () {
        sidebar.classList.remove("show");
    });

    sidebar_close_js_hide.addEventListener("click", function () {
        sidebar.classList.remove("show");
    });

    /*
    right_side_header_chat_option.addEventListener("click", function() {
        right_side_header_chat_option.classList.toggle('show')
    })

    document.addEventListener('click', function(event) {
        var isClickInside = right_side_header_chat_option.contains(event.target);
      
        if (!isClickInside) {
            right_side_header_chat_option.classList.remove('show')
        }
    });
    */

    right_side_chat_message_input.addEventListener("focus", (e) => {
        markAsSeen();
    });

    /*
    archive_conversation_option.addEventListener('click', function(e) {    
        e.preventDefault();        
        if (current_conversation_uuid == '') return false;
        var formData = new FormData();
        formData.append('conversation', current_conversation_uuid);
        
        axios.post(routes.archive_conversation, formData)
        .then((response) => {
            //console.log(response);
            if (response.data.success) {
                right_side_no_conversation.classList.remove('d-none')
                right_side.classList.add('d-none')
                sidebar.classList.add('d-none')
                document.querySelector(`.conversations .conversation-item[data-id="${current_conversation_uuid}"]`).remove();
                current_conversation_uuid = ''
                chat_back_btn.click();
            }
        })
        .catch(function (error) {
            //console.log(error);
        })
        .then(function () {
            //
        }); 
    });
    */

    /* MESSAGE INPUT AUTO HEIGHT */
    right_side_chat_message_input.style.height =
        right_side_chat_message_input.setAttribute(
            "style",
            "height: " + right_side_chat_message_input.scrollHeight + "px"
        );
    right_side_chat_message_input.classList.add("auto");
    right_side_chat_message_input.addEventListener("input", (e) => {
        right_side_chat_message_input.style.height = "auto";
        right_side_chat_message_input.style.height =
            right_side_chat_message_input.scrollHeight + "px";
    });

    /* SEND MESSAGE WHEN CLICK ENTER */
    right_side_chat_message_input.addEventListener("keydown", (e) => {
        const keyCode = e.which || e.keyCode;
        if (keyCode == 13 && !e.shiftKey) {
            e.preventDefault();
            right_side_chat_message_submit.click();
            return false;
        }
    });

    /* SEND MESSAGE */
    right_side_chat_message_submit.addEventListener("click", function (e) {
        e.preventDefault();

        temporaryMsgId += 1;
        let temp_id = "temp_" + temporaryMsgId;
        var file = right_side_chat_file_input.files[0];

        var formData = new FormData();
        formData.append("conversation", current_conversation_uuid);
        formData.append("message", right_side_chat_message_input.value);
        formData.append("temp_id", temp_id);
        if (file) {
            if (image_mimes.includes(file.type)) {
                formData.append("attachment", file);
                formData.append("attachment_type", "image");
            } else if (file_mimes.includes(file.type)) {
                formData.append("attachment", file);
                formData.append("attachment_type", "file");
            }
        }

        addmessageHtml(right_side_chat_message_input.value, file, temp_id);
        right_side_chat_content.scrollTop =
            right_side_chat_content.scrollHeight;

        axios
            .post(routes.send_message, formData)
            .then((response) => {
                //console.log(response);
                if (response.data.success) {
                    if (
                        response.data.conversation == current_conversation_uuid
                    ) {
                        var tmp_message = document.querySelector(
                            `.chat-content .chat .message[data-tmp-id="${response.data.temp_id}"]`
                        );
                        var parent_message_el = tmp_message.parentNode;
                        tempDiv = document.createElement("div");
                        tempDiv.innerHTML = response.data.message_html;
                        var response_el = tempDiv.childNodes[0];
                        parent_message_el.replaceChild(
                            response_el,
                            tmp_message
                        );
                        recent_message_id = response.message_id;
                    }
                    document
                        .querySelector(
                            `.conversations .conversation-item[data-id="${response.data.conversation}"]`
                        )
                        .remove();
                    active_conversations.insertAdjacentHTML(
                        "afterbegin",
                        response.data.conversation_html
                    );
                    document
                        .querySelector(
                            `.conversations .conversation-item[data-id="${response.data.conversation}"]`
                        )
                        .classList.add("active");
                    initConversationItemsEventListner();
                }
            })
            .catch(function (error) {
                //console.log(error)
                document
                    .querySelector(
                        `.chat-content .chat .message[data-tmp-id="${temp_id}"]`
                    )
                    .classList.add("ms-error");
            })
            .then(function () {
                loading_conversations = false;
            });
        remove_attachments[0].click();
        remove_attachments[1].click();
        right_side_chat_message_input.value = "";
        right_side_chat_message_input.dispatchEvent(input_event);
    });

    /* SEND MESSAGE */
    right_side_chat_file_attach_btn.addEventListener("click", function (e) {
        right_side_chat_file_input.click();
    });

    right_side_chat_file_input.addEventListener("change", function (e) {
        image_attachment_preview.classList.add("d-none");
        file_attachment_preview.classList.add("d-none");
        let file = this.files[0];
        let reader = new FileReader();
        if (image_mimes.includes(file.type)) {
            reader.readAsDataURL(file);
            reader.onloadend = function () {
                imageExists(reader.result, function () {
                    image_attachment_preview.classList.remove("d-none");
                    image_attachment_preview.querySelector(
                        ".file-name"
                    ).innerHTML = file.name;
                    image_attachment_preview.querySelector(".image-file").src =
                        reader.result;
                    tmp_image = reader.result;
                });
            };
        } else if (file_mimes.includes(file.type)) {
            file_attachment_preview.classList.remove("d-none");
            file_attachment_preview.querySelector(".file-name").innerHTML =
                file.name;
        } else {
            right_side_chat_file_input.value = "";
        }
    });

    remove_attachments.forEach((remove_attachment) => {
        remove_attachment.addEventListener("click", function (e) {
            remove_attachment.parentElement.classList.add("d-none");
            right_side_chat_file_input.value = "";
            tmp_image = "";
        });
    });

    function getConversations(type_conversation = "active") {
        var formData = new FormData();
        formData.append("type_conversation", type_conversation);
        if (loading_conversations) return false;
        loading_conversations = true;
        axios
            .post(routes.get_conversations, formData)
            .then((response) => {
                //console.log(response);
                if (response.data.success) {
                    //console.log(active_conversations)
                    active_conversations.innerHTML = "";
                    active_conversations.insertAdjacentHTML(
                        "afterbegin",
                        response.data.conversations
                    );
                    initConversationItemsEventListner();
                    if (current_conversation_uuid != "") {
                        document
                            .querySelector(
                                `.conversations .conversation-item[data-id='${current_conversation_uuid}']`
                            )
                            .classList.add("active");
                    }
                    if (url_id_params != null && first_url_load) {
                        var tmp_url_conv = document.querySelector(
                            `.conversations .conversation-item[data-id="${url_id_params}"]`
                        );
                        if (tmp_url_conv) tmp_url_conv.click();
                        first_url_load = false;
                    }
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .then(function () {
                loading_conversations = false;
            });
    }

    function initConversationItemsEventListner() {
        var conversation_items = document.querySelectorAll(
            ".conversations .conversation-item"
        );

        conversation_items.forEach((conversation_item) => {
            if (conversation_item.getAttribute("click-listener") !== "true") {
                conversation_item.addEventListener("click", function (e) {
                    e.preventDefault();
                    //console.log(e.target)
                    if (e.target.classList.contains("mark-as-unseen")) {
                        //console.log(conversation_item.getAttribute('data-id'))
                        markAsUnSeen(conversation_item.getAttribute("data-id"));
                        return;
                    }
                    if (
                        current_conversation_uuid ==
                        conversation_item.getAttribute("data-id")
                    )
                        return;
                    current_conversation_uuid =
                        conversation_item.getAttribute("data-id");
                    //console.log(current_conversation_uuid)
                    oldest_message_id = false;
                    recent_message_id = false;
                    has_more_messages = true;
                    right_side_chat_message_input.value = "";
                    remove_attachments[0].click();
                    remove_attachments[1].click();
                    right_side_chat_messages.innerHTML = "";
                    demand_attribution_form.querySelector(".errors").innerHTML =
                        "";
                    tmp_image = "";
                    right_side_header_property_url.setAttribute(
                        "href",
                        conversation_item.getAttribute("data-property-url")
                    );
                    right_side_header_user_url.setAttribute(
                        "href",
                        conversation_item.getAttribute("data-user-url")
                    );
                    getMessages();
                    if (window.messenger_is_owner) {
                        getStudentInfo();
                        getPropertyInfo();
                    }
                    markAsSeen();
                    removeConversationItemsActive();
                    right_side_header_user_avatar.src =
                        conversation_item.querySelector(".user-avatar").src;
                    right_side_header_property_avatar.src =
                        conversation_item.querySelector(".property-avatar").src;
                    right_side_header_user_name.innerHTML =
                        conversation_item.querySelector(".user-name").innerHTML;
                    right_side_header_property_title.innerHTML =
                        conversation_item.querySelector(
                            ".property-title"
                        ).innerHTML;
                    right_side_header_property_title.setAttribute(
                        "href",
                        conversation_item.getAttribute("data-property-url")
                    );
                    conversation_item.classList.add("active");
                    right_side.classList.remove("d-none");
                    right_side_no_conversation.classList.add("d-none");
                    left_side.classList.add("hide");
                    right_side.classList.add("active");
                    if (
                        window.messenger_is_owner &&
                        !window.messenger_is_admin
                    ) {
                        sidebar.classList.remove("d-none");
                    }
                });
                conversation_item.setAttribute("click-listener", "true");
            }
        });
    }

    function removeConversationItemsActive() {
        var conversation_items = document.querySelectorAll(
            ".conversations .conversation-item"
        );
        conversation_items.forEach((conversation_item) => {
            conversation_item.classList.remove("active");
        });
    }

    function markAsSeen() {
        if (current_conversation_uuid == "") return false;
        var formData = new FormData();
        formData.append("conversation", current_conversation_uuid);
        var message_count = document.querySelector(
            `.conversations .conversation-item[data-id='${current_conversation_uuid}'] .new-message-count`
        );
        if (message_count) message_count.remove();
        axios
            .post(routes.mark_as_seen, formData)
            .then((response) => {
                //console.log(response);
                if (response.data.success) {
                    //
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .then(function () {
                //
            });
    }

    function markAsUnSeen(uuid) {
        if (uuid == "") return false;
        var formData = new FormData();
        formData.append("conversation", uuid);
        axios
            .post(routes.mark_as_unseen, formData)
            .then((response) => {
                //console.log(response);
                if (response.data.success && response.data.unread_count > 0) {
                    var last_message_container = document.querySelector(
                        `.conversations .conversation-item[data-id='${uuid}'] .last-message-container`
                    );
                    var new_message_count_el = document.createElement("span");
                    new_message_count_el.className = "new-message-count";
                    new_message_count_el.innerHTML = response.data.unread_count;
                    last_message_container.appendChild(new_message_count_el);
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .then(function () {
                //
            });
    }

    function getMessages() {
        var formData = new FormData();
        if (oldest_message_id !== false) {
            formData.append("oldest_id", oldest_message_id);
        }
        formData.append("conversation", current_conversation_uuid);
        loading_messages = true;

        axios
            .post(routes.get_messages, formData)
            .then((response) => {
                //console.log(response);
                if (response.data.success) {
                    if (
                        response.data.conversation == current_conversation_uuid
                    ) {
                        var first_child = right_side_chat_messages.firstChild;
                        right_side_chat_messages.insertAdjacentHTML(
                            "afterbegin",
                            response.data.messages
                        );
                        if (!oldest_message_id) {
                            right_side_chat_content.scrollTop =
                                right_side_chat_content.scrollHeight;
                        } else {
                            first_child.scrollIntoView(true);
                            right_side_chat_content.scrollBy(0, -15);
                        }
                        oldest_message_id = response.data.oldest_id;
                        has_more_messages = response.data.has_more;
                    }
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .then(function () {
                loading_messages = false;
            });
    }

    function updateMessages() {
        if (current_conversation_uuid == "") return false;
        var formData = new FormData();
        if (recent_message_id !== false)
            formData.append("recent_id", recent_message_id);
        formData.append("conversation", current_conversation_uuid);
        loading_messages = true;
        axios
            .post(routes.update_messages, formData)
            .then((response) => {
                if (response.data.success) {
                    if (
                        response.data.conversation == current_conversation_uuid
                    ) {
                        var first_child = right_side_chat_messages.firstChild;
                        right_side_chat_messages.insertAdjacentHTML(
                            "beforeend",
                            response.data.messages
                        );
                        right_side_chat_content.scrollTop =
                            right_side_chat_content.scrollHeight;
                        if (response.data.recent_id != "")
                            recent_message_id = response.data.recent_id;
                    }
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .then(function () {
                loading_messages = false;
            });
    }

    function getStudentInfo() {
        var formData = new FormData();
        formData.append("conversation", current_conversation_uuid);
        loading_student_info = true;
        sidebar.querySelector(".messenger-sidebar-content").innerHTML = "";

        axios
            .post(routes.get_student, formData)
            .then((response) => {
                //console.log(response);
                if (response.data.success) {
                    sidebar.querySelector(
                        ".messenger-sidebar-content"
                    ).innerHTML = response.data.student_info_html;
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .then(function () {
                loading_student_info = false;
            });
    }

    function getPropertyInfo() {
        var formData = new FormData();
        formData.append("conversation", current_conversation_uuid);
        loading_student_info = true;

        axios
            .post(routes.get_property, formData)
            .then((response) => {
                //console.log(response);dd/mm/yyyy
                if (response.data.success) {
                    const today = new Date();
                    demand_attribution_rooms_group.innerHTML = "";
                    response.data.rooms.forEach((v, index) => {
                        if (index === 0) {
                            demand_attribution_cost_rent_input.value =
                                v.cost_rent;
                            demand_attribution_cost_charges_input.value =
                                v.cost_charges;
                            demand_attribution_caution_input.value = v.caution;
                            demand_attribution_agency_fee_input.value =
                                v.agency_fee;
                            demand_attribution_cloe_fee_input.value =
                                v.cloe_fee;
                        }

                        demand_attribution_rooms_group.insertAdjacentHTML(
                            "beforeend",
                            addRoomOption(v)
                        );
                    });
                    try {
                        //demand_attribution_start_date_input_datepicker.destroy()
                        //demand_attribution_start_date_input.setAttribute('value', response.data.start_date)
                        demand_attribution_start_date_input_datepicker.setDate(
                            response.data.start_date
                        );
                        /*demand_attribution_start_date_input_datepicker = new Datepicker(demand_attribution_start_date_input, {
                        language: document.documentElement.lang,
                        format: 'dd/mm/yyyy',
                        //minDate: today_date,
                    }); */
                    } catch (error) {}
                    //demand_attribution_start_date_input_datepicker.setDate(today_date)
                }
            })
            .catch(function (error) {
                //console.log(error);
            })
            .then(function () {
                loading_student_info = false;
            });
    }

    function imageExists(url, callback) {
        var img = new Image();
        img.onload = function () {
            callback();
        };
        img.onerror = function () {};
        img.src = url;
    }

    document.addEventListener("change", (e) => {
        if (e.target.matches("#demand-rooms-group")) {
            var selectedOptions = Array.from(e.target.selectedOptions);
            var cost_rent = 0,
                cost_charges = 0,
                caution = 0;

            selectedOptions.forEach((option) => {
                cost_rent += Number(option.getAttribute("data-rent"));
                cost_charges += Number(option.getAttribute("data-charges"));
                caution += Number(option.getAttribute("data-caution"));
            });

            demand_attribution_cost_rent_input.value = cost_rent;
            demand_attribution_cost_charges_input.value = cost_charges;
            demand_attribution_caution_input.value = caution;

            property_contact_selected_rooms = [];
            property_contact_selected_rooms_date = [];
            property_contact_selected_rooms_min_duration = [];

            selectedOptions.forEach((option) => {
                property_contact_selected_rooms.push(option.value);
                property_contact_selected_rooms_date.push(
                    parseDate(
                        option.getAttribute("data-available-date"),
                        "dd/mm/yyyy"
                    )
                );
                property_contact_selected_rooms_min_duration.push(
                    option.getAttribute("data-min-duration")
                );
            });

            var property_contact_selected_rooms_date_sorted =
                property_contact_selected_rooms_date.sort((a, b) => b - a);

            if (property_contact_selected_rooms_date.length == 0) {
                demand_attribution_start_date_input_datepicker.setOptions({
                    minDate: today_date,
                });
                if (
                    today_date.getTime() >
                    demand_attribution_start_date_input_datepicker
                        .getDate()
                        .getTime()
                ) {
                    demand_attribution_start_date_input_datepicker.setDate(
                        today_date
                    );
                }
            } else {
                let latestAvailableDate =
                    property_contact_selected_rooms_date_sorted[0];

                demand_attribution_start_date_input_datepicker.setOptions({
                    minDate:
                        today_date.getTime() > latestAvailableDate.getTime()
                            ? today_date
                            : latestAvailableDate,
                });

                if (
                    demand_attribution_start_date_input_datepicker
                        .getDate()
                        .getTime() < latestAvailableDate.getTime()
                ) {
                    demand_attribution_start_date_input_datepicker.setDate(
                        latestAvailableDate
                    );
                }
            }
        }
    });

    function addRoomOption(room) {
        return `<option value="${room.value}" 
                        data-rent="${room.cost_rent}" 
                        data-charges="${room.cost_charges}" 
                        data-caution="${room.caution}" 
                        data-available-date="${room.available_from}">
                    ${room.text}
                </option>`;
    }

    function addmessageHtml(message, file, id) {
        var file_html = "";
        if (file) {
            if (image_mimes.includes(file.type)) {
                file_html = `
                <div class="message-image spotlight" data-src="${tmp_image}">
                    <img src="${tmp_image}" alt="">
                </div>
                `;
            } else if (file_mimes.includes(file.type)) {
                file_html = `
                <a class="message-file" href="#!">
                    <i class="fas fa-file"></i> ${file.name}
                </a>
                `;
            }
        }
        var html = `<div class="message self" data-tmp-id="${id}">
                        <div class="message-wrapper">
                            <div class="message-content">
                                ${message} 
                                ${file_html}
                            </div>
                        </div>
                    </div>`;

        right_side_chat_messages.insertAdjacentHTML("beforeend", html);
    }

    function addPushermessageHtml(payload) {
        var file_html = "";
        if (payload.has_attachment) {
            if (payload.type_attachment == "image") {
                file_html = `
                <div class="message-image spotlight" data-src="${payload.url_attachment}">
                    <img src="${payload.url_attachment}" alt="">
                </div>
                `;
            } else if (payload.type_attachment == "file") {
                file_html = `
                <a class="message-file" target="_blank" href="${payload.url_attachment}">
                    <i class="fas fa-file"></i> ${payload.name_attachment}
                </a>
                `;
            }
        }

        var self =
            payload.from_user != (owner_id !== null ? owner_id : user_id)
                ? ""
                : "self";

        if (payload.type == "new_contact") {
            var html = `<div class="message ${self}">
                <div class="message-wrapper">
                    <div class="message-content new-contact-message">
                        <div class="property-thumb">
                            <img src="${
                                payload.new_contact.property_thumb_url
                            }" alt="">                            
                        </div>
                        <div class="contact-message">
                            ${payload.message}
                            ${
                                payload.from_user != user_id
                                    ? `<button class="btn btn-primary modal-toggle w-100 mt-1" data-modal="NewDemandAttribution">${payload.new_contact.action_message}</button>`
                                    : ""
                            }
                        </div>
                    </div>
                </div>
                <div class="message-options">
                    <span class="message-date">${payload.time}</span>
                </div>
            </div>`;
        } else {
            var html = `<div class="message ${self}">
                <div class="message-wrapper">
                    <div class="message-content">
                        ${payload.message} 
                        ${file_html}
                    </div>
                </div>
                <div class="message-options">
                    <span class="message-date">${payload.time}</span>
                </div>
            </div>`;
        }

        right_side_chat_messages.insertAdjacentHTML("beforeend", html);
    }

    //Demand Attribution Form
    demand_attribution_form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (new_demand_attribution) return false;
        var formData = new FormData(demand_attribution_form);
        formData.append("conversation", current_conversation_uuid);
        new_demand_attribution = true;
        demand_attribution_form
            .querySelector("[type=submit]")
            .setAttribute("disable", "true");
        var tmp_submit_inner =
            demand_attribution_form.querySelector("[type=submit]").innerHTML;
        demand_attribution_form.querySelector("[type=submit]").innerHTML =
            html_spin;
        demand_attribution_form.querySelector(".errors").innerHTML = "";
        axios
            .post(routes.add_new_demand_attribution, formData)
            .then((response) => {
                //console.log(response);
                if (response.data.success) {
                    demand_attribution_modal.style.display = "none";
                    demand_attribution_modal.classList.remove("show");
                    // Remove Bootstrap modal backdrop if present
                    var backdrop = document.querySelector(
                        ".modal-backdrop.show"
                    );
                    if (backdrop) {
                        backdrop.parentNode.removeChild(backdrop);
                    }
                    document.body.style.overflowY = "auto";
                    updateMessages();
                }
            })
            .catch(function (error) {
                console.log(error);
                //console.log(error.response);
                if (error.response.data.errors_html) {
                    demand_attribution_form.querySelector(".errors").innerHTML =
                        error.response.data.errors_html;
                }
            })
            .then(function () {
                new_demand_attribution = false;
                demand_attribution_form
                    .querySelector("[type=submit]")
                    .setAttribute("disable", "false");
                demand_attribution_form.querySelector(
                    "[type=submit]"
                ).innerHTML = tmp_submit_inner;
            });
    });

    profile_completion_request_btn.addEventListener("click", function (e) {
        e.preventDefault();
        if (profile_complete_request) return false;
        if (current_conversation_uuid == "") return false;
        if (!window.messenger_is_owner) return false;
        var formData = new FormData();
        formData.append("conversation", current_conversation_uuid);
        profile_complete_request = true;
        var tmp_submit_inner = profile_completion_request_btn.innerHTML;
        profile_completion_request_btn.innerHTML = html_spin;
        axios
            .post(routes.profile_completion_request, formData)
            .then((response) => {
                //console.log(response);
                if (response.data.success) {
                    //
                }
            })
            .catch(function (error) {})
            .then(function () {
                profile_complete_request = false;
                profile_completion_request_btn.setAttribute("disable", "false");
                profile_completion_request_btn.innerHTML = tmp_submit_inner;
            });
    });

    if (
        typeof window.Echo !== "undefined" &&
        window.Echo.connector &&
        window.Echo.connector.pusher &&
        typeof window.Echo.private === "function"
    ) {
        let messenger_channel = window.Echo.private("messenger." + user_id);

        messenger_channel.listen(".message", (e) => {
            if (e.from_user != user_id) {
                try {
                    new_message_sound.play();
                } catch (error) {}
            }
            var tmp_conv = document.querySelector(
                `.conversations .conversation-item[data-id="${e.conversation_uuid}"]`
            );
            if (tmp_conv) tmp_conv.remove();
            active_conversations.insertAdjacentHTML(
                "afterbegin",
                e[`conversation_html_${user_id}`]
            );
            initConversationItemsEventListner();
            if (e.conversation_uuid === current_conversation_uuid) {
                document
                    .querySelector(
                        `.conversations .conversation-item[data-id="${e.conversation_uuid}"]`
                    )
                    .classList.add("active");
                //addPushermessageHtml(e)
                right_side_chat_messages.insertAdjacentHTML(
                    "beforeend",
                    e.html_message
                );
                right_side_chat_content.scrollTop =
                    right_side_chat_content.scrollHeight;
                if (window.isDocVisible && window.isDocFocus) {
                    markAsSeen();
                }
                recent_message_id = e.message_id;
            }
        });

        messenger_channel.listen(".archived", (e) => {
            var tmp_conv = document.querySelector(
                `.conversations .conversation-item[data-id="${e.conversation_uuid}"]`
            );
            if (tmp_conv) tmp_conv.remove();
            if (e.conversation_uuid === current_conversation_uuid) {
                //console.log('archived')
                right_side_no_conversation.classList.remove("d-none");
                right_side.classList.add("d-none");
                chat_back_btn.click();
            }
        });

        messenger_channel.listen(".markAsRead", (e) => {
            var message_count = document.querySelector(
                `.conversations .conversation-item[data-id='${e.conversation_uuid}'] .new-message-count`
            );
            if (message_count) message_count.remove();
        });

        window.Echo.connector.pusher.connection.bind("connected", (payload) => {
            connexion++;

            if (connexion > 1) {
                window.ensureIsConnected(timeout).then(function () {
                    right_side_no_conversation.classList.remove("d-none");
                    right_side.classList.add("d-none");
                    document
                        .querySelector("#messenger-sidebar")
                        .classList.add("d-none");
                    sidebar.querySelector(
                        ".messenger-sidebar-content"
                    ).innerHTML = "";
                    sidebar.querySelector(
                        ".messenger-sidebar-actions"
                    ).innerHTML = "";

                    chat_back_btn.click();
                    getConversations();
                    //updateMessages();
                });
            }
        });
    }

    // AJAX delete for messenger messages
    document.addEventListener("submit", function (e) {
        if (e.target.classList.contains("messenger-message-delete-form")) {
            e.preventDefault();
            var form = e.target;
            var messageId = form.getAttribute("data-message-id");
            var action = form.getAttribute("action");
            var formData = new FormData(form);
            axios
                .delete(action, { data: formData })
                .then(function (response) {
                    if (response.data.success) {
                        // Remove the message from the DOM
                        var messageEl = form.closest(".message");
                        if (messageEl) messageEl.remove();
                    }
                    updateMessages();
                })
                .catch(function (error) {
                    // Optionally show an error message
                });
        }
    });

    var edit_demand_attribution_form = document.querySelector(
        "#messenger-edit-demand-attribution"
    );
    var demand_attribution_edit_start_date_input =
        edit_demand_attribution_form.querySelector("#edit_start_date");

    var today_date = new Date();
    today_date.setHours(0, 0, 0, 0);

    var demand_attribution_edit_start_date_input_datepicker = new Datepicker(
        demand_attribution_edit_start_date_input,
        {
            language: document.documentElement.lang,
            format: "dd/mm/yyyy",
            minDate: today_date,
        }
    );

    // Edit Demand Attribution Modal logic
    document.addEventListener("click", function (e) {
        if (
            e.target.classList.contains("modal-toggle") &&
            e.target.dataset.modal === "EditDemandAttribution"
        ) {
            e.preventDefault();
            // Get the parent message element
            var messageEl = e.target.closest(".message");
            // Get values from data attributes on the button or message element
            // For now, assume the button has data attributes for each field
            var btn = e.target;
            var modal = document.getElementById("EditDemandAttribution");
            var form = modal.querySelector("form");
            // Set values (add more fields as needed)
            demand_attribution_edit_start_date_input_datepicker.setDate(
                btn.getAttribute("data-start_date")
            );

            form.querySelector("#owner_id").value =
                btn.getAttribute("data-owner_id");

            form.querySelector("#demand_attribution_id").value =
                btn.getAttribute("data-demand_attribution_id") || "";

            form.querySelector("#edit_cost_rent").value =
                btn.getAttribute("data-cost_rent") / 100 || 0;
            form.querySelector("#edit_cost_charges").value =
                btn.getAttribute("data-cost_charges") / 100 || 0;
            form.querySelector("#edit_caution").value =
                btn.getAttribute("data-caution") / 100 || 0;
            form.querySelector("#edit_agency_fee").value =
                btn.getAttribute("data-agency_fee") / 100 || 0;
            form.querySelector("#edit_cloe_fee").value =
                btn.getAttribute("data-cloe_fee") / 100 || 0;
            // Show the modal
            modal.style.display = "block";
        }
    });

    if (edit_demand_attribution_form) {
        edit_demand_attribution_form.addEventListener("submit", function (e) {
            e.preventDefault();
            if (new_demand_attribution) return false;
            var formData = new FormData(edit_demand_attribution_form);
            var demandAttributionId =
                edit_demand_attribution_form.getAttribute("data-id") ||
                formData.get("demand_attribution_id");
            var ownerId = formData.get("owner_id");
            if (!demandAttributionId) {
                edit_demand_attribution_form.querySelector(
                    ".errors"
                ).innerHTML = "ID missing.";
                return;
            }
            new_demand_attribution = true;
            var submitBtn =
                edit_demand_attribution_form.querySelector("[type=submit]");
            var tmp_submit_inner = submitBtn.innerHTML;
            submitBtn.setAttribute("disable", "true");
            submitBtn.innerHTML = html_spin;
            edit_demand_attribution_form.querySelector(".errors").innerHTML =
                "";
            axios
                .post(
                    routes.update_demand_attribution
                        .replace(":id", demandAttributionId)
                        .replace(":owner_id", ownerId),
                    formData
                )
                .then((response) => {
                    if (response.data.success) {
                        document.getElementById(
                            "EditDemandAttribution"
                        ).style.display = "none";

                        document
                            .getElementById("EditDemandAttribution")
                            .classList.remove("show");
                        // Remove Bootstrap modal backdrop if present
                        var backdrop = document.querySelector(
                            ".modal-backdrop.show"
                        );
                        if (backdrop) {
                            backdrop.parentNode.removeChild(backdrop);
                        }
                        document.body.style.overfl;
                    }
                })
                .catch(function (error) {
                    if (error.response && error.response.data.errors_html) {
                        edit_demand_attribution_form.querySelector(
                            ".errors"
                        ).innerHTML = error.response.data.errors_html;
                    }
                })
                .then(function () {
                    new_demand_attribution = false;
                    submitBtn.setAttribute("disable", "false");
                    submitBtn.innerHTML = tmp_submit_inner;
                });
        });
    }

    // Cancel Demand Attribution functionality
    document.addEventListener("click", function (e) {
        if (e.target.classList.contains("cancel-demand-attribution-btn")) {
            e.preventDefault();
            console.log("Cancel button clicked");
            var btn = e.target;
            var form = btn.closest(".ajax-cancel-demand-attribution-form");
            var url = form.getAttribute("data-action");
            var formData = new FormData(form);

            console.log("URL:", url);
            console.log("Form data:", formData);

            // Disable the button and show loading state
            btn.disabled = true;
            var originalText = btn.innerHTML;
            btn.innerHTML = html_spin + " Annuler";

            axios
                .post(url, formData, {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        Accept: "application/json",
                        "X-CSRF-TOKEN": document
                            .querySelector('meta[name="csrf-token"]')
                            .getAttribute("content"),
                    },
                })
                .then(function (response) {
                    console.log("Response:", response);
                    if (response.data.success) {
                        updateMessages();
                    } else {
                        //alert("Erreur lors de l'annulation.");
                    }
                })
                .catch(function (error) {
                    console.error("Error:", error);
                    //alert("Erreur lors de l'annulation.");
                })
                .finally(function () {
                    // Re-enable the button
                    btn.disabled = false;
                    btn.innerHTML = originalText;
                });
        }
    });

    // Delete Demand Attribution functionality
    document.addEventListener("click", function (e) {
        if (e.target.classList.contains("delete-demand-attribution-btn")) {
            e.preventDefault();
            console.log("Delete button clicked");
            var btn = e.target;
            var form = btn.closest(".ajax-delete-demand-attribution-form");
            var url = form.getAttribute("data-action");
            var formData = new FormData(form);

            console.log("URL:", url);
            console.log("Form data:", formData);

            // Disable the button and show loading state
            btn.disabled = true;
            var originalText = btn.innerHTML;
            btn.innerHTML = html_spin + " Supprimer";

            axios
                .delete(url, {
                    data: formData,
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        Accept: "application/json",
                        "X-CSRF-TOKEN": document
                            .querySelector('meta[name="csrf-token"]')
                            .getAttribute("content"),
                    },
                })
                .then(function (response) {
                    if (response.data.success) {
                        // Remove the message from the DOM
                        var messageEl = btn.closest(".message");
                        if (messageEl) {
                            messageEl.remove();
                        }
                    }
                })
                .catch(function (error) {
                    console.error("Error:", error);
                    //alert("Erreur lors de la suppression.");
                })
                .finally(function () {
                    // Re-enable the button
                    btn.disabled = false;
                    btn.innerHTML = originalText;
                    updateMessages();
                });
        }
    });
}
